import { Environments } from '@/config';
import { HELIX_ROCHESTER_PRODUCTION } from './helix-rochester.production';
import { HELIX_ROCHESTER_STAGING } from './helix-rochester.staging';

export const HELIX_ROCHESTER =
  import.meta.env.MODE === Environments.PROD ? HELIX_ROCHESTER_PRODUCTION : HELIX_ROCHESTER_STAGING;
